import { Routes } from "@angular/router"
import { PrivacyPolicyComponent } from "./privacy-policy.component"

export const privacyPolicyRoutes: Routes = [
    { path: "", component: PrivacyPolicyComponent },
]
